<template>
  <v-form
    v-model="valid"
    class="py-8 bg-light-blue-main"
    @submit.prevent>
    <div class="pa-4">
      <v-container class="bordered bg-white">
        <NormalInput
          :id="nodeId"
          field="variant_name"
          icon="variant"
          :return-object="false"
          component="v-combobox"
          :items="nameSuggestions" />
      </v-container>
    </div>

    <ElementButtons
      :disabled-delete="
        Number(spaceStore.getElement(nodeId)?.is_active_part) === 1
      "
      disabled-delete-message="active-variant"
      hide-submit
      :node-id="nodeId"
      :valid="valid"
      :custom-delete-action="customDeleteAction" />

    <VariantTabs :node-id="nodeId" />
  </v-form>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { useTranslation } from "i18next-vue";
import { useRoute } from "vue-router";

import { useCommonRules } from "@/validations/common";

import ElementButtons from "@/components/Elements/ElementButtons.vue";
import VariantTabs from "./VariantTabs.vue";
import { useSpaceStore } from "../../../stores/spaceStore";
import { useTreeStore } from "@/stores/treeStore";
import NormalInput from "@/components/Elements/NormalInput.vue";

const { t } = useTranslation();
const spaceStore = useSpaceStore();
const treeStore = useTreeStore();
const route = useRoute();
const { required } = useCommonRules(t);

const nameSuggestions = computed(() => {
  return [
    "Basis",
    "Potenzial x",
    "Nachkalkulation vom " + new Date().toLocaleDateString()
  ];
});

const nodeId = computed(() => route.params.nodeId.replace("variant", "part"));

const valid = ref(false);

const partParentId = computed(() => {
  return treeStore.breadcrumpElements[
    treeStore.elementBreadcrumbs[route.params.nodeId].at(-2)
  ].id;
});

const customDeleteAction = () => {
  spaceStore.removeElement(nodeId.value, partParentId.value, true);
};
</script>
